import { ICON_AGENCIES, ICON_CALENDAR, ICON_CONTRACTS } from "common/constants";
import React from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const ContractorsItem = ({ data, index }: { data: any; index?: number }) => {
  const details = [
    data?.acronym && `<span class="fw-medium">Acronym:</span> ${data.acronym}`,
    data?.organizationType &&
      `<span class="fw-medium">Organization Type:</span> ${data.organizationType}`,
    data?.previousOrAliasName &&
      `<span class="fw-medium">Previous or Alias Name:</span> ${data.previousOrAliasName}`,
    data?.emailAddress &&
      `<span class="fw-medium">Email Address:</span> ${data.emailAddress}`,
    data?.postalAddress &&
      `<span class="fw-medium">Postal Address:</span> ${data.postalAddress}`,
    data?.physicalAddress &&
      `<span class="fw-medium">Physical Address:</span> ${data.physicalAddress}`,
    data?.website && `<span class="fw-medium">Website:</span> ${data.website}`,
    data?.contractorRegistration?.length > 0 &&
      `<span class="fw-medium">Contractor Registration:</span> ${data.contractorRegistration
        .map((item: any) => item)
        .join(", ")}`,
    // data?.capacityAssessments &&
    //   data?.capacityAssessments?.map((item: any) => item).join(", "),
    // data?.pvrs && data?.pvrs?.map((item: any) => item).join(", "),
    // data?.riskAssessments &&
    //   data?.riskAssessments?.map((item: any) => item).join(", "),
    // data?.semgMentions &&
    //   data?.semgMentions?.map((item: any) => item).join(", "),
    // data?.performanceRatings &&
    //   data?.performanceRatings?.map((item: any) => item).join(", "),
    // data?.contracts && data?.contracts?.map((item: any) => item).join(", "),
    // data?.boardOfDirectors &&
    //   data?.boardOfDirectors?.map((item: any) => item).join(", "),
  ].filter(Boolean);

  const detailsString = React.useMemo(() => details.join(", "), [details]);

  // Create a unique ID for this component instance to scope the styles
  const componentId = React.useMemo(
    () =>
      `contractor-item-${
        data?.id || Math.random().toString(36).substring(2, 9)
      }`,
    [data?.id]
  );

  return (
    <div className={index === 0 ? "pb-3" : "py-3"} id={componentId}>
      {/* Add scoped styles for highlighting em tags */}
      <style>
        {`
          #${componentId} em {
            background-color: #fff59d;
            font-style: normal;
            padding: 0 0px;
            border-radius: 2px;
            font-weight: 500;
          }
        `}
      </style>
      <h5 className="mb-1">
        <Link to={`/contractors/${data.id}`}>
          <span
            dangerouslySetInnerHTML={{ __html: data?.contractorName || "" }}
          ></span>
        </Link>
      </h5>
      <p className="text-success mb-2 align-items">
        <span className="me-2 text-capitalize">Contractor</span>
        {/* <span className="badge bg-success-subtle text-success fs-11 me-2">
          <i className="ri-account-circle-line align-bottom"></i> Contractors
        </span> */}
        {data?.semgMentions && data?.semgMentions?.length > 0 && (
          <span className="badge bg-warning-subtle text-warning fs-11 me-2">
            SEMG Mention
          </span>
        )}
      </p>
      <p
        className="text-muted mb-2"
        dangerouslySetInnerHTML={{ __html: `... ${detailsString} ...` }}
      ></p>

      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item me-3">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                {moment(new Date(data?.updatedAt)).format("DD MMM Y")}
              </span>
            </div>
          </div>
        </li>
        <li className="list-inline-item me-3">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_AGENCIES}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">0 Agencies</span>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CONTRACTS}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">{`${data?.contracts?.length} Contracts`}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ContractorsItem;
